// extracted by mini-css-extract-plugin
export default {"container":"promotion-description_container__18jX8"};